
import { useState } from "react";
import styled from 'styled-components'
import Logo from './Logo'
import Menus from './Menus'
import ButtonCtrl from './ButtonCtrl'
import ToggleBar from './ToggleBar'

const Navbar = styled.div`
    box-shadow: 0 2px 4px 0 rgba(2,2,2,.4);
    display: flex;
    justify-content: center;

    .navbar__container{
        max-width: 1280px;
        width: 1280px;
        padding: 5px 20px;
        display: flex;
        justify-content: space-between;
        ${props => props.expanded == true ? "" : "overflow: hidden;"};

        .left{
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .right{
            display: flex;
            position: relative;
        }
    }

    @media only screen and (max-width: 768px) {
        .navbar__container{
            width: 100%;
        }
    }

    @media only screen and (max-width: 450px) {
        .navbar__container{
            width: 100%;
            .left{
                display: flex;
            }
        }
    }
`

export default function Index(props) {
    const [navToggle, setNavToggle] = useState(false)
    return (
        <Navbar className={"navbar" + (props.className ? props.className : '')} expanded={navToggle}>
            <div className="navbar__container">
                <div className="left">
                    <Logo/>
                </div>
                <div className="right">
                    <div className="menu-container">
                        <Menus expanded={navToggle} fncToggleNavBar={() => { setNavToggle(!navToggle); }}/>
                    </div>
                    <ButtonCtrl />
                    <ToggleBar className="navbar-toggle__expanded" expanded={navToggle} fncToggleNavBar={() => { setNavToggle(!navToggle); }}/>
                </div>
            </div>
        </Navbar>
    )
}
